/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './EnhancedPersonalServiceBenefits.scss';

import React, { Fragment } from 'react';

import Content from 'services/Content';
import {
  enhancedPersonalServicesLinks,
  coreServicesLinks,
  transactions
} from 'services/Externals';
import { SERVICE_TYPE_CORE } from 'services/ServiceBenefits';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import BenefitsBox from './BenefitsBox';
import { contentConverter } from 'services/Content';
import FinePrint from 'components/layouts/Preferences/Benefits/FinePrint';
import LinkButton from 'components/shared/Buttons/LinkButton';
import turboTaxLogo from 'assets/turbotax-logo.png';
import Accordion from 'components/layouts/Preferences/Benefits/Accordion/Accordion';
import TurboTaxTable from 'components/layouts/Preferences/Benefits/TurboTaxTable';

import { linkBuilder } from 'services/Externals';

const CoreBenefits = ({ view }) => {
  const turboTaxAccordionHeader = (
    <Fragment>
      <img src={turboTaxLogo} alt="TurboTax Logo" />
      <LinkButton
        link={coreServicesLinks.turboTaxLink}
        className="eps-button"
        linkTarget="_blank">
        Save Now
      </LinkButton>
    </Fragment>
  );

  return (
    <Fragment>
      <PreferencesHeader>
        <div className="eps-benefits-header">TurboTax® Discounts</div>
      </PreferencesHeader>
      <PreferencesSection fullBackground className="eps-benefits-page">
        <PreferencesRow>
          <Accordion
            title={<h3>Save up to $20 on TurboTax.</h3>}
            headerChildren={turboTaxAccordionHeader}
            bodyChildren={<TurboTaxTable accountType={SERVICE_TYPE_CORE} />}
            alwaysOpen
          />
        </PreferencesRow>
      </PreferencesSection>
      <div className="flex-container">
        <BenefitsBox link={linkBuilder(coreServicesLinks.directDeposit, view)}>
          <div
            dangerouslySetInnerHTML={{
              __html: contentConverter.makeHtml(
                Content.coreServicesDirectDeposit
              )
            }}
          />
        </BenefitsBox>
        <BenefitsBox link={transactions.otherLinks.seeAllTransactions}>
          <div
            dangerouslySetInnerHTML={{
              __html: contentConverter.makeHtml(Content.iraContributionBenefit)
            }}
          />
        </BenefitsBox>
        <BenefitsBox link={coreServicesLinks.collegeSavings}>
          <div
            dangerouslySetInnerHTML={{
              __html: contentConverter.makeHtml(
                Content.coreServicesCollegeSavings
              )
            }}
          />
        </BenefitsBox>
        <BenefitsBox link={enhancedPersonalServicesLinks.charitableGiving}>
          <div
            dangerouslySetInnerHTML={{
              __html: contentConverter.makeHtml(Content.charitableGivingBenefit)
            }}
          />
        </BenefitsBox>
      </div>
      <FinePrint content={Content.turboTaxDisclaimer} />
    </Fragment>
  );
};

export default CoreBenefits;
